module.exports = __webpack_public_path__ + "img/saturnina.1144dc75.jpg";